<template>
    <div v-if="versions.length" class="flex align-items-center gap-3">
        <label class="text-color-secondary">{{ $t('lang.serp.report.version_label') }}</label>
        <AdaptersDropdown
            :modelValue="ver"
            :options="versions"
            optionLabel="label"
            optionValue="value"
            @change="onChange"
            class="serp_version_selector__input"
            panelClass="p-dropdown-panel-sm"
            append-to="body"
        >
            <template #dropdownicon>
                <i class="pi pi-calendar" />
            </template>
        </AdaptersDropdown>
    </div>
</template>

<script>
import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
import {Listeners} from "../../../constants/listeners";

/**
 * «Дата съёма» в шапке отчёта онлайн-парсера выдачи.
 * Список съёмов и выбранный приходят из SerpProjectsPage через $emitter, выбор уходит туда же.
 */
export default {
    name: "SerpVersionSelector",
    data() {
        return {
            versions: [],
            ver: null,
        }
    },
    created() {
        this.$emitter.on(Listeners.SERP_VERSIONS_STATE, this.onState);
    },
    beforeUnmount() {
        this.$emitter.off(Listeners.SERP_VERSIONS_STATE, this.onState);
    },
    methods: {
        onState({versions, ver}) {
            this.versions = versions;
            this.ver = ver;
        },
        onChange(e) {
            this.ver = e.value;
            this.$emitter.emit(Listeners.SERP_VERSION_CHANGE, e.value);
        },
    },
    components: {
        AdaptersDropdown,
    },
}
</script>

<style scoped>
.serp_version_selector__input:deep(.p-dropdown-label) {
    padding: 0.5rem 1rem;
}
.serp_version_selector__input:deep(.p-dropdown-trigger) {
    width: 2.75rem;
    background-color: var(--surface-200);
    border-left: 1px solid var(--surface-border);
    color: var(--text-color-secondary);
}
</style>
